import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MapPin } from "lucide-react";

interface VenueStepProps {
  venue: string;
  onVenueChange: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
  firstName: string;
}

const VenueStep = ({ 
  venue, 
  onVenueChange, 
  onNext, 
  onBack,
  firstName 
}: VenueStepProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="flex flex-col items-center text-center"
    >
      <div className="mb-6">
        <MapPin className="w-12 h-12 text-primary mx-auto mb-4" />
        <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-2">
          Where are you celebrating{firstName ? `, ${firstName}` : ""}?
        </h2>
        <p className="text-muted-foreground">
          Tell us about your venue (or "TBD" if you're still deciding!)
        </p>
      </div>

      <div className="w-full max-w-md space-y-4 mb-8">
        <div className="space-y-2 text-left">
          <Label htmlFor="venue">Venue Name & Location</Label>
          <Input
            id="venue"
            value={venue}
            onChange={(e) => onVenueChange(e.target.value)}
            placeholder="e.g., The Estate at Florentine Gardens, NJ"
            className="text-center md:text-left"
          />
        </div>
        
        <p className="text-sm text-muted-foreground">
          We serve couples in New Jersey, Florida, Colorado & beyond!
        </p>
      </div>

      <div className="flex gap-3 w-full max-w-md">
        <Button
          variant="outline"
          onClick={onBack}
          className="flex-1"
        >
          Back
        </Button>
        <Button
          onClick={onNext}
          className="flex-1"
        >
          Continue
        </Button>
      </div>
    </motion.div>
  );
};

export default VenueStep;
